// lib/telefonie/status.ts
// Ob der angemeldete Mitarbeiter sein Webex-Konto verbunden hat. Gemerkt wird das
// PAAR aus Benutzer-Kennung und Antwort, nicht nur die Antwort allein: App.tsx meldet
// SIGNED_IN/SIGNED_OUT über onAuthStateChange, lädt die Seite dabei aber nicht neu —
// ohne die Kennung im Merker würde ein Nutzerwechsel im selben Tab den Status des
// vorigen Nutzers erben. Zusätzlich verwirft TelefonieKarte.tsx den Merker aktiv beim
// Verbinden/Trennen (das ändert die Antwort für die GLEICHE Kennung).
import { supabase } from '../supabase/client';

interface Gemerkt {
  benutzerId: string | null;
  ergebnis: Promise<boolean>;
}

let gemerkt: Gemerkt | null = null;

export function verwirfTelefonieStatus(): void {
  gemerkt = null;
}

export async function istTelefonieVerbunden(): Promise<boolean> {
  // getSession() liest aus dem lokalen Speicher, kein Netzwerk-Roundtrip — die
  // Kennung ist also praktisch kostenlos zu haben, bevor wir dem Cache trauen.
  const { data: { session } } = await supabase.auth.getSession();
  const benutzerId = session?.user?.id ?? null;

  if (!gemerkt || gemerkt.benutzerId !== benutzerId) {
    gemerkt = { benutzerId, ergebnis: ladeStatus() };
  }
  return gemerkt.ergebnis;
}

async function ladeStatus(): Promise<boolean> {
  try {
    const { data } = await supabase
      .from('v_telefonie_benutzer_status')
      .select('ist_gueltig')
      .maybeSingle();
    return !!data?.ist_gueltig;
  } catch {
    return false;
  }
}
